<template>
<div class="BranchVN">
    <h1> THÔNG TIN LUÔN ĐƯỢC CẬP NHẬT </h1>
    <!-- chi nhánh huế -->
    <div class="thong-tin col-md-12" >
       <h4>Chi nhánh Huế - Cơ sở 1</h4>
     </div>
    <div class="image-address">
        <img src="../assets/logo52NguyenSinhCung.jpg" style="width: 30%"/>
    </div>
    <div class="text-address footer">
        <h4 style="color: blue">Địa chỉ liên hệ: 52 Nguyễn Sinh Cung, Phường Vỹ Dạ, Thành Phố Huế</h4>
        <h4 style="color:red">TEL: 096 858 2306 ( zalo ) </h4>
        <h4 style="color:red">Người liên hệ: MAI LOAN </h4>
    </div>
    <div class="image-address">
        <img src="https://i.pinimg.com/originals/1c/cf/d1/1ccfd19ac52d63e5e307309780bf9b66.jpg" style="width: 30%"/>
    </div>
    <div class="thong-tin col-md-12" >
       <h4>Chi nhánh Huế - Cơ sở 2</h4>
     </div>
    <div class="image-address">
        <img src="https://i.pinimg.com/originals/c7/25/8c/c7258c2eff48ecdf03844bfefc19a233.jpg" style="width: 30%"/>
    </div>
    <div class="text-address footer">
        <h4 style="color: blue">Địa chỉ liên hệ: 192 Phan Chu Trinh, Thành Phố Huế</h4>
        <h4 style="color:red">TEL: 034 854 1554 ( zalo ) </h4>
        <h4 style="color:red">Người liên hệ: THU PHONG </h4>
    </div>
    <div class="image-address">
        <img src="https://i.pinimg.com/originals/9e/28/17/9e28178fe7c7b13778bf21a313024f01.jpg" style="width: 30%"/>
    </div>
    <!-- chi nhánh Ninh Bình -->
    <div class="thong-tin col-md-12" >
       <h4>Chi nhánh Ninh Bình</h4>
     </div>
    <div class="image-address footer">
        <img src="../assets/logoNinhBinh.jpg" style="width: 30%"/>
    </div>
    <div class="text-address">
        <h4 style="color: blue">Địa chỉ liên hệ: 333 PHỐ BÌNH YÊN TÂY - PHƯỜNG NINH KHÁNH - TP NINH BÌNH</h4>
        <h4 style="color:red">TEL: 0335.300.888 </h4>
        <h4 style="color:red">Người liên hệ: HOÀNG DUY </h4>
    </div>
    <!-- chi nhánh Hà Nội -->
    <div class="thong-tin col-md-12" >
       <h4>Chi nhánh Hà Nội</h4>
     </div>
    <div class="image-address footer">
        <img src="../assets/logoHaNoi.jpg" style="width: 30%"/>
    </div>
    <div class="text-address">
        <h4 style="color: blue">Địa chỉ liên hệ: 11e - 160 ĐƯỜNG BẠCH ĐẰNG - HÀ NỘI</h4>
        <h4 style="color:red">TEL: 035.305.4038 </h4>
        <h4 style="color:red">Người liên hệ: HIỀN </h4>
    </div>
    <!-- chi nhánh HCM -->
    <div class="thong-tin col-md-12" >
       <h4>Chi nhánh Hồ Chí Minh</h4>
     </div>
    <div class="image-address footer">
        <img src="../assets/logoHCM.jpg" style="width: 30%"/>
    </div>
    <div class="text-address footer">
        <h4 style="color: blue">Địa chỉ liên hệ: 317 ĐƯỜNG SỐ 5 - BÌNH HƯNG HÒA - BÌNH TÂN - TP.HCM</h4>
        <h4 style="color:red">TEL: 093.4824.775 </h4>
        <h4 style="color:red">Người liên hệ: MAI LỆ </h4>
    </div>
    <div class="footer"></div>
</div>
</template>

<script>

import Constants from "@/components/Constants/Constants.js"
export default {
    name: 'BranchVN',
}
</script>
<style scoped>
.BranchVN{
    margin-top: 160px;
    text-align: center;
     margin-right: 30px;
  margin-left: 30px;
}
.thong-tin{
  border-radius: 25px 0px 0px 25px;
  background-color: #34baeb;
  color: white;
  padding-top: 10px;
  padding-bottom: 4px;
  margin-bottom: 1em;
  margin-top: 1em;
  text-align: left !important;
 
}
.footer{
    margin-bottom: 30px !important;
}
</style>